/**
 * isAppleDevice — true on iPhone/iPad/iPod and Mac, where maps.apple.com opens
 * the native Maps app. Mirrors the user-agent check injected in base.njk so the
 * server-rendered links and the React islands agree. iPadOS 13+ reports itself
 * as "Macintosh", which this matches as well.
 */
export function isAppleDevice() {
    if (typeof navigator === 'undefined') return false;
    return /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent);
}
